import { callRpc } from './base';
import { ensureObject } from './util';

export interface UpdateProgramFeesPrizesParams {
  program_id: string;
  entry_fee: number | null;
  entry_fee_currency: string | null;
  cost_range: string | null;
  prize_structure: Record<string, unknown> | null;
  prizes_per_category: number | null;
  prize_types: string[] | null;
  total_win_opportunities: number | null;
  has_tiered_prizes: boolean | null;
  primary_currency: string | null;
  extra_benefits: string | null;
  qc_flag_fees_prizes: boolean | null;
  qc_flag_fees_prizes_notes: string | null;
  editor_id?: string | null;
}

export interface UpdateProgramFeesPrizesResult {
  program_id: string;
  program_code: string | null;
  fees_prizes_id: string | null;
  updated_at: string;
}

export const updateProgramFeesPrizes = async (
  params: UpdateProgramFeesPrizesParams
): Promise<UpdateProgramFeesPrizesResult> => {
  return await callRpc('update_program_fees_prizes', {
    params: {
      p_program_id: params.program_id,
      p_entry_fee: params.entry_fee,
      p_entry_fee_currency: params.entry_fee_currency,
      p_cost_range: params.cost_range,
      p_prize_structure: params.prize_structure,
      p_prizes_per_category: params.prizes_per_category,
      p_prize_types: params.prize_types,
      p_total_win_opportunities: params.total_win_opportunities,
      p_has_tiered_prizes: params.has_tiered_prizes,
      p_primary_currency: params.primary_currency,
      p_extra_benefits: params.extra_benefits,
      p_qc_flag_fees_prizes: params.qc_flag_fees_prizes,
      p_qc_flag_fees_prizes_notes: params.qc_flag_fees_prizes_notes,
      p_editor_id: params.editor_id ?? null
    },
    transform: (payload) =>
      ensureObject<UpdateProgramFeesPrizesResult>(
        payload,
        'INVALID_UPDATE_FEES_PRIZES_RESPONSE',
        'update_program_fees_prizes RPC returned invalid data',
        { program_id: params.program_id }
      )
  });
};

export default updateProgramFeesPrizes;
